import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

interface HasModules {
    hasLms: boolean;
    hasPlaylist: boolean;
    hasBuzz: boolean;
}

export function useHasModules(): HasModules {
    const { moduleIds } = useSelector(({ identity }: ApplicationState) => ({
        moduleIds: (identity.data.user && identity.data.user.moduleIds) || [],
    }));

    const [hasLms, setHasLms] = useState<boolean>(false);
    const [hasPlaylist, setHasPlaylist] = useState<boolean>(false);
    const [hasBuzz, setHasBuzz] = useState<boolean>(false);

    useEffect(() => {
        setHasLms(!!moduleIds.find((x) => x === Constants.LMS_MODULE_ID));
        setHasPlaylist(!!moduleIds.find((x) => x === Constants.PLAYLIST_MODULE_ID));
        //setHasBuzz(!!moduleIds.find((x) => x === Constants.BUZZ_MODULE_ID));
    }, [moduleIds]);

    return { hasLms, hasPlaylist, hasBuzz };
}
